import axios from "axios";
import axiosRetry from "axios-retry";
import Constants from "common/constant";

export const client = ({ token }: { token: string }) => {
  const client = axios.create({ baseURL: Constants.apiHost });
  client.defaults.headers.common["Authorization"] = token;
  client.defaults.headers.common["Content-Type"] = "application/json";
  axiosRetry(client, {
    retries: 3,
    // 4xx は何度投げても同じ答えが返る。403 の投稿が4回飛んでいたのでやり直さない
    // （通信エラー・タイムアウト・5xx と、混雑を表す 408/429 だけやり直す）
    retryCondition: (error) => {
      const status = error.response?.status;
      if (status === undefined) return true;
      return status >= 500 || status === 408 || status === 429;
    },
    retryDelay: function (_retryCount, _error) {
      return 1000;
    },
  });
  return client;
};
